<template>
  <span
    :class="captionClasses"
    data-cy="ds-label__caption"
  >
    <span
      v-if="$slots.prefix"
      :class="DS_LABEL_CLASSES.Prefix"
      data-cy="ds-label__prefix"
    >
      <slot name="prefix" />
    </span>
    <span
      v-if="props.label"
      v-ds-tooltip="props.tooltip"
      :class="DS_LABEL_CLASSES.Text"
      data-cy="ds-label__text"
    >
      {{ props.label }}
    </span>
    <span
      v-if="required"
      :class="DS_LABEL_CLASSES.RequiredAsterisk"
      data-cy="ds-label__required-asterisk"
    >
      *
    </span>
    <span
      v-if="$slots.suffix"
      :class="DS_LABEL_CLASSES.Suffix"
      data-cy="ds-label__suffix"
    >
      <slot name="suffix" />
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed, type VNode } from "vue";
import { DSLabelContentProps } from "@/src/design_system/form_elements/label/types/props";
import { DS_LABEL_CLASSES } from "@/src/design_system/form_elements/label/constants/classes";
import { vDsTooltip } from "@/src/design_system/primitives/tooltip/directives/vDsTooltip";

const props = withDefaults(defineProps<DSLabelContentProps>(), {
  required: false,
  tooltip: undefined,
  hiddenLabel: false,
});

/**
 * Callers decide whether an affix carries meaningful content; a forwarded slot outlet always
 * looks non-empty from here, so this component only reacts to the slot being provided at all.
 */
defineSlots<{
  prefix?: () => VNode[];
  suffix?: () => VNode[];
}>();

const captionClasses = computed(() => ({
  [DS_LABEL_CLASSES.Caption]: true,
  [DS_LABEL_CLASSES.CaptionHidden]: props.hiddenLabel,
}));
</script>
